import store from '../../store';
import { setAlert } from '../../store/alerts/slice';
import ALERT_TYPES from '../../store/alerts/constants';

/**
 * Pops an success message on the application
 * @param {string} message - Message to show
 * @return {void}
 */
export const showSuccessMessage = (message) => {
  store.dispatch(setAlert({
    type: ALERT_TYPES.success,
    message,
  }));
};

/**
 * Pops an error message on the application
 * @param {string} message - Message to show
 * @return {void}
 */
export const showErrorMessage = (message) => {
  store.dispatch(setAlert({
    type: ALERT_TYPES.error,
    message,
  }));
};
